import React from "react";

import Button, { ButtonTypes } from "../../../components/Button";
import {
  Caption,
  PageContent,
  PageHeader,
  PageHeading,
  PageTitle,
} from "../styles";
import { AttentionList } from "./components/AttentionList";
import { BackgroundJobs } from "./components/BackgroundJobs";
import { HealthStrip } from "./components/HealthStrip";
import { SchedulerList } from "./components/SchedulerList";
import { useAdminOverview } from "./hooks/useAdminOverview";
import { SectionGrid } from "./styles";

export const AdminOverviewPage: React.FC = () => {
  const { sections, retries, attentionItems, isRefreshing, refreshAll } =
    useAdminOverview();
  const refreshLabel = isRefreshing ? "Refreshing…" : "Refresh";

  return (
    <PageContent>
      <PageHeader>
        <PageTitle>
          <PageHeading>Operations overview</PageHeading>
          <Caption>
            Monitor data health and resolve what needs attention.
          </Caption>
        </PageTitle>
        <Button
          type={ButtonTypes.cancel}
          size="small"
          disabled={isRefreshing}
          onClick={refreshAll}
        >
          {refreshLabel}
        </Button>
      </PageHeader>
      <HealthStrip sections={sections} />
      <AttentionList
        items={attentionItems}
        sections={sections}
        retries={retries}
      />
      <SectionGrid>
        <BackgroundJobs
          snapshotQueue={sections.snapshotQueue}
          backfillQueue={sections.backfillQueue}
          onRetrySnapshotQueue={retries.snapshotQueue}
          onRetryBackfillQueue={retries.backfillQueue}
        />
        <SchedulerList
          schedulers={sections.schedulers}
          onRetry={retries.schedulers}
        />
      </SectionGrid>
    </PageContent>
  );
};
